export default [
  {
    path: '/applyCenter',
    name: 'applyCenter',
    component: () => import('@/views/applyCenter/Index.vue'),
    meta: { title: 'apply_center_h5', zhTitle: '报名中心', pageLevel: 2 }
  },
  {
    path: '/applyDetail',
    name: 'applyDetail',
    component: () => import('@/views/applyCenter/Detail.vue'),
    meta: { title: 'apply_details_h5', zhTitle: '报名详情', pageLevel: 3 }
  }
]
